// ShirtCard.jsx
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { CartContext } from '../cart/ContextProvider';
import LoginModal from '../Authentication/Loginmodal'; // Update the path

const ShirtCard = ({ shirt }) => {
  const { wishlist, addToWishlist, removeFromWishlist, user } = useContext(CartContext);
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  function handleClick() {
    navigate(`/product/${shirt.id}`);
  }

  async function handleAddToWishlist(event) {
    event.stopPropagation();

    // Check if the user is logged in
    if (user) {
      await addToWishlist(shirt);
    } else {
      // If not logged in, show the login modal
      setShowLoginModal(true);
    }
  }

  async function handleRemoveFromWishlist(event) {
    event.stopPropagation();

    // Check if the user is logged in
    if (user) {
      await removeFromWishlist(shirt.id);
    } else {
      // If not logged in, show the login modal
      setShowLoginModal(true);
    }
  }

  function handleImageLoaded() {
    setImageLoaded(true);
  }

  const isItemInWishlist = wishlist.some((wishlistItem) => wishlistItem.id === shirt.id);

  return (
    <div className='Cards' onClick={() => handleClick()}>
      <div className='imgOnCard'>
        {isItemInWishlist ? (
          <div className='favorite-icon' onClick={handleRemoveFromWishlist}>
            <FavoriteIcon className='FavoriteIcon' style={{ fontSize: 'medium' }} />
          </div>
        ) : (
          <div className='favorite-border-icon' onClick={handleAddToWishlist}>
            <FavoriteBorderIcon className='FavoriteBorderIcon' style={{ fontSize: 'medium' }} />
          </div>
        )}
        <img
          src={shirt.image}
          alt={shirt.brand}
          style={{ display: imageLoaded ? 'block' : 'none' }}
          onLoad={handleImageLoaded}
        />
      </div>
      <div className='cardDetails'>
        <h3>{shirt.name}</h3>
        <hr />
        <div className='row'>
          <div className='cardPrize'>
            <p className='card-brand'>{shirt.brand}</p>
            <p className='rupees'> &#8377; {Math.floor(shirt.price)}</p>
          </div>
        </div>
      </div>

      {/* Display the login modal if showLoginModal is true */}
      <LoginModal
        isOpen={showLoginModal}
        onRequestClose={() => setShowLoginModal(false)}
        onLoginClick={() => {
          // Add logic to handle login button click
          setShowLoginModal(false);
          // Redirect to the login page
          navigate("/login");
        }}
      />
    </div>
  );
};

export default ShirtCard;
